import { AdminCategory, ADMIN_CATEGORIES } from "../../../../models/Categories";
import IntegrationCategoryCard from "./IntegrationCategoryCard";
import { IntegrationForIntegrationBuilder } from "../../utils/Entities";

interface IntegrationCategorySelectionProps {
  requestBodyForIntegration: IntegrationForIntegrationBuilder | undefined;
  setRequestBodyForIntegration: React.Dispatch<
    React.SetStateAction<IntegrationForIntegrationBuilder | undefined>
  >;
}

const IntegrationCategorySelection = ({
  requestBodyForIntegration,
  setRequestBodyForIntegration,
}: IntegrationCategorySelectionProps) => {
  const selectedCategories = requestBodyForIntegration?.categories
    ? requestBodyForIntegration.categories
    : [];

  const handleCategoryClick = (category: AdminCategory) => {
    if (selectedCategories.includes(category)) {
      setRequestBodyForIntegration((body) => {
        return { ...body, categories: selectedCategories.filter((c) => c !== category) };
      });
    } else {
      setRequestBodyForIntegration((body) => {
        return { ...body, categories: [...selectedCategories, category] };
      });
    }
  };

  return (
    <div className="grid grid-cols-[repeat(auto-fit,_minmax(297px,_1fr))] gap-4">
      {ADMIN_CATEGORIES.map((category) => (
        <IntegrationCategoryCard
          key={category}
          category={category}
          selected={selectedCategories.includes(category)}
          onClick={() => handleCategoryClick(category)}
        />
      ))}
    </div>
  );
};

export default IntegrationCategorySelection;
